export const EMPTY_PICKUP = {
  retiradaPai: false, retiradaMae: false, retiradaOutrosQuantidade: 0,
  ...Object.fromEntries([1, 2, 3].flatMap(n => ['Nome', 'Parentesco', 'Telefone'].map(field => [`saidaAcompanhada${field}${n}`, '']))),
};

const clean = value => String(value || '').trim();
export const pickupOtherCount = form => Math.min(3, Math.max(0, Number(form.retiradaOutrosQuantidade) || 0));

// Pai/mãe são referências aos campos atuais, nunca cópias independentes.
export const getAuthorizedPickupPeople = form => {
  if (form.autorizaSaidaSozinho !== 'nao') return [];
  const people = [];
  if (form.retiradaPai && !form.naoTemPai) people.push({
    key: 'pai', name: clean(form.nomePai), relationship: 'Pai', phone: clean(form.celularPai) || clean(form.telefonePai),
  });
  if (form.retiradaMae && !form.naoTemMae) people.push({
    key: 'mae', name: clean(form.nomeMae), relationship: 'Mãe', phone: clean(form.celularMae) || clean(form.telefoneMae),
  });
  for (let n = 1; n <= pickupOtherCount(form); n += 1) people.push({
    key: `outro${n}`, name: clean(form[`saidaAcompanhadaNome${n}`]),
    relationship: clean(form[`saidaAcompanhadaParentesco${n}`]), phone: clean(form[`saidaAcompanhadaTelefone${n}`]),
  });
  return people;
};

export const validatePickup = form => {
  if (form.autorizaSaidaSozinho !== 'nao') return {};
  const people = getAuthorizedPickupPeople(form);
  const errors = {};
  if (!people.length) errors.retiradaAutorizados = 'Selecione pai, mãe ou adicione outra pessoa autorizada.';
  people.forEach(person => {
    if (person.key === 'pai' || person.key === 'mae') {
      if (!person.name || !person.phone) errors[`retirada${person.key === 'pai' ? 'Pai' : 'Mae'}`] = `Complete nome e telefone da ${person.key === 'pai' ? 'filiação do pai' : 'filiação da mãe'} acima.`;
    } else {
      const n = person.key.replace('outro', '');
      if (!person.name) errors[`saidaAcompanhadaNome${n}`] = 'Informe o nome da pessoa autorizada.';
      if (!person.relationship) errors[`saidaAcompanhadaParentesco${n}`] = 'Informe o parentesco ou vínculo.';
      if (!person.phone) errors[`saidaAcompanhadaTelefone${n}`] = 'Informe o telefone da pessoa autorizada.';
    }
  });
  return errors;
};

export const pickupPeopleSummary = form => getAuthorizedPickupPeople(form).map(person => {
  if (person.key === 'pai') return `Pai: ${person.name} (Tel: ${person.phone})`;
  if (person.key === 'mae') return `Mae: ${person.name} (Tel: ${person.phone})`;
  return `Outra pessoa: ${person.name} (Parentesco: ${person.relationship}; Tel: ${person.phone})`;
}).join(' * ');

// Lê o mesmo resumo legível enviado à Sponte, sem criar contrato ou tabela novos.
export const readPickupFromObservation = observation => {
  const result = { ...EMPTY_PICKUP, autorizaSaidaSozinho: 'nao' };
  const section = clean(observation).match(/\*{3}\s*AUTORIZACOES\s*\*{3}\s*([\s\S]*?)(?=\s*\*{3}|$)/i)?.[1];
  if (!section) return result;
  if (/^AUTORIZADO a sair sozinho/i.test(section)) return { ...result, autorizaSaidaSozinho: 'sim' };
  const entries = section.split(/Pessoas autorizadas:\s*/i)[1]?.split(/\s+\*\s+/) || [];
  entries.forEach(entry => {
    if (/^Pai:/i.test(entry)) { result.retiradaPai = true; return; }
    if (/^M[aã]e:/i.test(entry)) { result.retiradaMae = true; return; }
    const current = entry.match(/^Outra pessoa:\s*(.*?)\s*\(Parentesco:\s*(.*?);\s*Tel:\s*(.*?)\)\s*$/i);
    const legacy = entry.match(/^(.*?)\s*\(Tel:?\s*(.*?)\)\s*$/i);
    if ((!current && !legacy) || result.retiradaOutrosQuantidade >= 3) return;
    const n = ++result.retiradaOutrosQuantidade;
    result[`saidaAcompanhadaNome${n}`] = current?.[1] || '';
    result[`saidaAcompanhadaParentesco${n}`] = current?.[2] || legacy?.[1] || '';
    result[`saidaAcompanhadaTelefone${n}`] = current?.[3] || legacy?.[2] || '';
  });
  return result;
};
